import { getMixpanelClient } from '@Src/mfe.config';
import { TrackingPayloadBuilder } from '@Analytics/trackingPayloadBuilder';
import { EVENT } from '@Constants/tracking.constants';


export const trackClientDeviceMfaValidated = (context: string, validationType: string, codeResentFlag: boolean) => {
    const trackingObject = new TrackingPayloadBuilder(context)
        .withValidationType(validationType)
        .withCodeResentFlag(codeResentFlag)
        .build();
    getMixpanelClient()?.track(EVENT.ClientDeviceMfaValidated, trackingObject);
};

export const trackClientIdentityViewedInstructions = (context : string) => {
    const trackingObject = new TrackingPayloadBuilder(context)
    .build();
    getMixpanelClient()?.track(EVENT.ClientIdentityInstructionsViewed, trackingObject);
}

export const trackClientIdentityStarted = (context: string, supportLinkViewed: boolean) => {
    const trackingObject = new TrackingPayloadBuilder(context)
    .withSupportLinkVist(supportLinkViewed)
    .build();
    getMixpanelClient()?.track(EVENT.ClientIdentityStarted, trackingObject);
}

export const trackClientIdentityDocTypeSelected = (context: string, docTypeName: string) => {
    const trackingObject = new TrackingPayloadBuilder(context)
    .withCustomField("docTypeSelected", docTypeName)
    .build();
    getMixpanelClient()?.track(EVENT.ClientIdentityDocTypeSelected, trackingObject);
}

export const trackFullKycStarted = (context: string) => {
    const trackingObject = new TrackingPayloadBuilder(context).build();
    getMixpanelClient()?.track(EVENT.ClientFullKycStarted, trackingObject);
};

export const trackFullKycCompleted = (context: string, supportLinkVisited: boolean) => {
    const trackingObject = new TrackingPayloadBuilder(context)
        .withSupportLinkVist(supportLinkVisited)
        .build();
    getMixpanelClient()?.track(EVENT.ClientFullKycCompleted, trackingObject);
};
